/* eslint-disable no-undef */
if (process.env.VUE_APP_BUILD_MODE === 'production') {
  !(function(e, t, n, g, i) {
    (e[i] =
      e[i] ||
      function() {
        (e[i].q = e[i].q || []).push(arguments);
      }),
      (n = t.createElement('script')),
      (tag = t.getElementsByTagName('script')[0]),
      (n.async = 1),
      (n.src =
        (document.location.protocol == 'https:' ? 'https://' : 'http://') + g),
      tag.parentNode.insertBefore(n, tag);
  })(window, document, 'script', 'assets.growingio.com/2.1/gio.js', 'gio');

  gio('init', 'b516e6a694e779ef', {});
  // custom page code begin here
  gio('config', {
    hashtag: true
  });
  // custom page code end here
  gio('send');
}
